import { Component, OnInit, OnDestroy, Input,AfterViewInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import {FileService} from "../../../_services/file.service";
import { AcademicInfoService } from '../../../_services/index';
//import { FormDoneService } from '../../../_services/form-done.service';
//import { DOCUMENT } from '@angular/platform-browser';
import {Http} from "@angular/http";
import {ViewEncapsulation} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {MatDialog} from '@angular/material';
import{DialogPdfComponent} from '../dialog-pdf/dialog.component';

@Component({
  selector: 'app-academic-information',
  templateUrl: './academic-information.component.html',
  styleUrls: ['./academic-information.component.css'],
  providers:[FileService,AcademicInfoService]
})
export class AcademicInformationComponent implements OnInit, OnDestroy {

  @Output() userUpdated: EventEmitter<any> = new EventEmitter<any>();

  academicForm: FormGroup;
  formChangeSub: Subscription;
  getdataSub: Subscription;
  submitdataSub: Subscription;
  fileuploadSub: Subscription;
  highSchoolSub: Subscription;
  
  public graduateYear: string;
  public isGraduate: any;
  public isParticipateCareer: any;
  public isParticipateOther: boolean;
  highSchoolsData :any;
  error: boolean;
  errorFlag: boolean;
  successMessage: string;
  errorMessage: string;
  submitBtnText = '';
  submitting: boolean;
  fieldErrors:any;
  public personalEmail: string;
  currentUser:any;
  loading: boolean;
  public checkChange: boolean;
  public valueChange = false;
  public canDeactivateCheck = false;
  public checkingSubmit = false;
  public filename;
  public filepath;
  showCareerAcademy = false;
  showhighSchool = false;
  public yearData=[];
  pdf: any;
  pdfSrc: string = '';
  showCareerOther = false;
  highschoolId;
  loadingTemplate = '<h1>Loading</h1>';
  
  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private _fileService:FileService,
    public api: AcademicInfoService,   
    private route: ActivatedRoute,
    public http: Http,
    private _sanitizer: DomSanitizer,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.createForm();
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.personalEmail=this.currentUser?this.currentUser.email:'';
    this.academicForm.get('personalEmail').setValue(this.personalEmail);
    this.createDynamicYear();
    //this.highSchoolsList();
    this.getAcademicInfo();
    window.scrollTo(300, 500);

  }

    createDynamicYear() {
        let currentYear = new Date().getFullYear();
        //for (let i = 1960; i<= currentYear+4; i++) {
          for (let i = 1960; i<= 2021; i++) {
            let item = {}
            item['year'] = i;
            this.yearData.push(item)
        }
    }

  ngOnDestroy() {
    
    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }
    if (this.getdataSub)  {
      this.getdataSub.unsubscribe();
    }
    if (this.submitdataSub)  {
      this.submitdataSub.unsubscribe();
    }
    if (this.fileuploadSub)  {
      this.fileuploadSub.unsubscribe();
    }
    if (this.highSchoolSub)  {
      this.highSchoolSub.unsubscribe();
    }
    
  }

  ngAfterViewInit() {
   
    var element1 = document.querySelector('.droppable1');
    this.makeDroppable(element1, this.callback,this);

    var element2 = document.querySelector('.droppable2');
    this.makeDroppable(element2, this.callback,this);
  }

  private _onValueChanged() {
    
    if(this.checkChange)
    {
      //console.log('aca');
      this.valueChange = true

    }
        
  }

  createForm()  {
    this.academicForm  = this._fb.group({
      //continent:['summ'],
      personalEmail: ['', [Validators.required]],      
      highSchoolName: ['',[Validators.required]],
      graduateYear: ['',[Validators.required]],
      isGraduate: ['',[Validators.required]],
      isParticipateCareer: ['',[Validators.required]],
      AgricultureNaturalResources: [''],
      ArtMediaEntertainment: [''],
      BuildingConstructionTechnologies: [''],
      BusinessFinance: [''],
      Education: [''],
      EnergyEnvironmentUtilities: [''],
      EngineeringArchitecture: [''],
      FashionInteriorDesign: [''],
      HealthSciencesMedicalTechnology: [''],
      HospitalityTourismRecreation: [''],
      InformationCommunicationTechnologies: [''],
      ManufacturingProductDevelopment: [''],
      MarketingSalesServices: [''],
      PublicServices: [''],
      Transportation: [''],
      isParticipateOther: ['',[Validators.required]],
      AVID: [''],
      GATE: [''],
      InternationalBaccalaureate: [''],
      ROTC: [''],
      UpwardBound: [''],
      Other: [''],
      otherSpecify:[''],
      fileId:['']
      
    });

    this.formChangeSub = this.academicForm
    .valueChanges
    .subscribe(data => this._onValueChanged());
    this._onValueChanged();

  }

  onSubmit()  {
    this.loading = true;
    const carrer_sectors = JSON.stringify({
      AgricultureNaturalResources: this.academicForm.controls.AgricultureNaturalResources.value==true?1:0,
      ArtMediaEntertainment: this.academicForm.controls.ArtMediaEntertainment.value==true?1:0,
      BuildingConstructionTechnologies: this.academicForm.controls.BuildingConstructionTechnologies.value==true?1:0,
      BusinessFinance: this.academicForm.controls.BusinessFinance.value==true?1:0,
      Education: this.academicForm.controls.Education.value==true?1:0,
      EnergyEnvironmentUtilities: this.academicForm.controls.EnergyEnvironmentUtilities.value==true?1:0,
      EngineeringArchitecture: this.academicForm.controls.EngineeringArchitecture.value==true?1:0,
      FashionInteriorDesign: this.academicForm.controls.FashionInteriorDesign.value==true?1:0,
      HealthSciencesMedicalTechnology: this.academicForm.controls.HealthSciencesMedicalTechnology.value==true?1:0,
      HospitalityTourismRecreation: this.academicForm.controls.HospitalityTourismRecreation.value==true?1:0,
      InformationCommunicationTechnologies: this.academicForm.controls.InformationCommunicationTechnologies.value==true?1:0,
      ManufacturingProductDevelopment: this.academicForm.controls.ManufacturingProductDevelopment.value==true?1:0,
      MarketingSalesServices: this.academicForm.controls.MarketingSalesServices.value==true?1:0,
      PublicServices: this.academicForm.controls.PublicServices.value==true?1:0,
      Transportation: this.academicForm.controls.Transportation.value==true?1:0,
      
    });

    const other_sectors = JSON.stringify({
      AVID: this.academicForm.controls.AVID.value==true?1:0,
      GATE: this.academicForm.controls.GATE.value==true?1:0,
      InternationalBaccalaureate: this.academicForm.controls.InternationalBaccalaureate.value==true?1:0,
      ROTC: this.academicForm.controls.ROTC.value==true?1:0,
      UpwardBound: this.academicForm.controls.UpwardBound.value==true?1:0,
      Other: this.academicForm.controls.Other.value==true?1:0
      
    });

    let highSchoolName = this.academicForm.controls.highSchoolName.value;
    
    let recentClg;
    //console.log(highSchoolName);
    //console.log(typeof highSchoolName);
    //console.log(this.highschoolId);
    if(typeof highSchoolName === 'object')
    {
      recentClg = this.academicForm.controls.highSchoolName.value.id;
    }
    else{
      recentClg = this.highschoolId;

    }

    const body = JSON.stringify({
      highSchoolName: recentClg,
      graduateYear: this.academicForm.controls.graduateYear.value,
      isGraduate: this.academicForm.controls.isGraduate.value,
      isParticipateCareer: this.academicForm.controls.isParticipateCareer.value,
      carrer_sectors:carrer_sectors,
      isParticipateOther: this.academicForm.controls.isParticipateOther.value,
      other_sectors:other_sectors,
      personalEmail:this.academicForm.controls.personalEmail.value,
      fileId:this.academicForm.controls.fileId.value,
      otherSpecify:this.academicForm.controls.otherSpecify.value,
      
    });
    //console.log(body);
    this.submitting = true;
    this.api.postAcademicInfo$(body)
      .subscribe(
        data => {
          this.error = false;
          this.submitting = false;
          const response = data;
          //if (response.success === 1 && response.statusCode === 200) {
            this.errorFlag = false;
            this.loading = false;
            this.successMessage = response.message;
            if(!this.canDeactivateCheck)
            {
              
              this.checkingSubmit = true;
              this.router.navigate(['/profile/background-information']);
            }
            
        },
        error => {
          this.submitting = false;
          this.errorFlag = true;
          const errordata = JSON.parse(error._body);
          if (errordata.success === 0) {
            this.errorMessage = errordata.message;
            this.errorFlag = true;
            this.fieldErrors = errordata.errors;
          }
          this.loading = false;
        },
      );
    //console.log(this);
  }

  makeDroppable(element, callback,classObj) {
    
        var input = document.createElement('input');
        input.setAttribute('type', 'file');
        //input.setAttribute('multiple', 'true');
        input.style.display = 'none';

        input.addEventListener('change', function (e) {
            triggerCallback(e, classObj);
        });
        element.appendChild(input);

        element.addEventListener('dragover', function(e) {
            e.preventDefault();
            e.stopPropagation();
            element.classList.add('dragover');
        });

        element.addEventListener('dragleave', function(e) {
            e.preventDefault();
            e.stopPropagation();
            element.classList.remove('dragover');
        });

        element.addEventListener('drop', function(e) {
            e.preventDefault();
            e.stopPropagation();
            element.classList.remove('dragover');
            triggerCallback(e,classObj);
        });

        element.addEventListener('click', function() {
            input.value = null;
            input.click();
            //console.log(input);
        });

        function triggerCallback(e,obj) {
            var files;
            if(e.dataTransfer) {
                files = e.dataTransfer.files;
            } else if(e.target) {
                files = e.target.files;
            }
            callback.call(null, files,e,obj);
        }
    }
    
    
  callback(files, event, classobject?: any) {
      classobject.loading = true;
      for (let i = 0; i < files.length; i++) {
          let ext = '';
          //console.log(files[i]);
          // Here, we simply log the Array of files to the console.
          let mimeType = files[i].type;
          ext = files[i].name.split('.').pop();
          //console.log(ext);
          const allowedMIMEType = ['application/pdf'];
          if(allowedMIMEType.indexOf(mimeType)>= 0 ){
              if((allowedMIMEType.indexOf(mimeType) == 0) || (allowedMIMEType.indexOf(mimeType) == 1) ){

                  classobject.filetype = ext;

              }else{
                  classobject.filetype = ext;

              }
              //console.log(classobject.quoteId);
              const body = {
                  attachableId: '',
                  file: files[i],
                  attachableType:'Academic'
              };

              //console.log(body);
              
                    classobject.fileuploadSub = classobject._fileService.uploadFile(body).subscribe(

                    responsedata => {
                    //console.log(responsedata);
                    let fileId = JSON.parse(responsedata._body).data.fileId;
                    classobject.academicForm.controls["fileId"].setValue(fileId);

                    classobject.filename = files[i].name;
                    
                    let filelink = JSON.parse(responsedata._body).data.filelink;
                    classobject.filepath = filelink;

                    classobject.loading = false;
                  },
                  error => {

                    classobject.loading = false;
                  });

          }else{

              alert("File not allowed");
              classobject.loading = false;
          }
      }
      //console.log(classobject.uploadFilenames);

  }

  getAcademicInfo() {
    
    this.loading = true;
    const body = JSON.stringify({
          email: this.personalEmail
    });

    this.getdataSub = this.api.getAcademicInfo(body)
    
      .subscribe(responsedata => {
          //console.log(responsedata.data);
          let academicInfodata = responsedata.data;
          //console.log(academicInfodata.carrer_sectors);
          let carrer_sectors;
          if(academicInfodata.carrer_sectors)
          {
            carrer_sectors = JSON.parse(academicInfodata.carrer_sectors);

          }

          let other_sectors;
          if(academicInfodata.other_sectors)
          {
            other_sectors = JSON.parse(academicInfodata.other_sectors);

          }
          //console.log(carrer_sectors)
          //console.log(other_sectors)
          //console.log(JSON.parse(academicInfodata.carrer_sectors.json()));

          this.academicForm.controls['graduateYear'].setValue(academicInfodata.graduate_year);
          
          if(academicInfodata.is_graduate_from)
          {
            //console.log('wefw');
            this.academicForm.controls['isGraduate'].setValue(academicInfodata.is_graduate_from);
            
          }

          if(academicInfodata.is_participate_carrer)
          {
            //console.log('wefw');
            this.academicForm.controls['isParticipateCareer'].setValue(academicInfodata.is_participate_carrer);
            
          }

          if(academicInfodata.is_participate_other)
          {
            //console.log('wefw');
            this.academicForm.controls['isParticipateOther'].setValue(academicInfodata.is_participate_other);
            
          }

          this.academicForm.controls['otherSpecify'].setValue(academicInfodata.other_specify);
          this.academicForm.controls['fileId'].setValue(academicInfodata.fileid);
          this.filename = academicInfodata.orig_name;
          this.filepath = academicInfodata.full_path;
          if(carrer_sectors) {

            this.academicForm.controls['AgricultureNaturalResources'].setValue(carrer_sectors.AgricultureNaturalResources==1?true:false);
            this.academicForm.controls['ArtMediaEntertainment'].setValue(carrer_sectors.ArtMediaEntertainment==1?true:false);
            this.academicForm.controls['BuildingConstructionTechnologies'].setValue(carrer_sectors.BuildingConstructionTechnologies==1?true:false);
            this.academicForm.controls['BusinessFinance'].setValue(carrer_sectors.BusinessFinance==1?true:false);
            this.academicForm.controls['Education'].setValue(carrer_sectors.Education==1?true:false);
            this.academicForm.controls['EnergyEnvironmentUtilities'].setValue(carrer_sectors.EnergyEnvironmentUtilities==1?true:false);
            this.academicForm.controls['EngineeringArchitecture'].setValue(carrer_sectors.EngineeringArchitecture==1?true:false);
            this.academicForm.controls['FashionInteriorDesign'].setValue(carrer_sectors.FashionInteriorDesign==1?true:false);
            this.academicForm.controls['HealthSciencesMedicalTechnology'].setValue(carrer_sectors.HealthSciencesMedicalTechnology==1?true:false);
            this.academicForm.controls['HospitalityTourismRecreation'].setValue(carrer_sectors.HospitalityTourismRecreation==1?true:false);
            this.academicForm.controls['InformationCommunicationTechnologies'].setValue(carrer_sectors.InformationCommunicationTechnologies==1?true:false);
            this.academicForm.controls['ManufacturingProductDevelopment'].setValue(carrer_sectors.ManufacturingProductDevelopment==1?true:false);
            this.academicForm.controls['MarketingSalesServices'].setValue(carrer_sectors.MarketingSalesServices==1?true:false);
            this.academicForm.controls['PublicServices'].setValue(carrer_sectors.PublicServices==1?true:false);
            this.academicForm.controls['Transportation'].setValue(carrer_sectors.Transportation==1?true:false);          
            
          }
          
          if(other_sectors) {
            this.academicForm.controls['AVID'].setValue(other_sectors.AVID==1?true:false);          
            this.academicForm.controls['GATE'].setValue(other_sectors.GATE==1?true:false);          
            this.academicForm.controls['InternationalBaccalaureate'].setValue(other_sectors.InternationalBaccalaureate==1?true:false);          
            this.academicForm.controls['Other'].setValue(other_sectors.Other==1?true:false);          
            this.academicForm.controls['ROTC'].setValue(other_sectors.ROTC==1?true:false);          
            this.academicForm.controls['UpwardBound'].setValue(other_sectors.UpwardBound==1?true:false);          
          }

          this.showHidecareer();
          
          this.checkOther();
          
          this.showHideschool();
          this.loading = false;
          if(academicInfodata.high_school_id)
          {
            //console.log(academicInfodata.high_school_id);
            //console.log(JSON.parse(academicInfodata.high_school_id));
            this.highschoolId = JSON.parse(academicInfodata.high_school_id).id;
            //console.log(JSON.parse(academicInfodata.high_school_id).name);
            this.academicForm.controls['highSchoolName'].setValue(JSON.parse(academicInfodata.high_school_id).name);
            //console.log(this.highschoolId);
            setTimeout(()=>{
              this.loading = true;
              this.checkChange = true;
              this.loading = false;
              
            },2000);
          } 
          
        },
        err => {
          console.log(err);
        }
      
      );
  }

  canDeactivate() {
    
    //console.log('i am navigating away from academic');
    
    //console.log(this.valueChange);

    if(this.valueChange && this.checkingSubmit == false)
    {
      if(confirm("Want to save changes?")) {
        
        this.canDeactivateCheck = true;
        
        this.onSubmit();
      }
    }
      
    return true;
    
  }

  showHidecareer(){

    let isParticipateOther = this.academicForm.controls.isParticipateOther.value;
    
    //console.log(isParticipateOther);

    if(isParticipateOther == '0' || isParticipateOther == '')
    {
      this.showCareerAcademy = true;
    }
    else{
      this.showCareerAcademy = false;
    }
  }

  checkOther() {

    let Other = this.academicForm.controls.Other.value==true?1:0;
    
    //console.log(Other);

    if(Other == 0)
    {
      this.showCareerOther = true;
    }
    else{
      this.showCareerOther = false;
    }

  }

  showHideschool() {
    //console.log('qwdqwd');
    let isParticipateCareer = this.academicForm.controls.isParticipateCareer.value;
    
    //console.log(isParticipateCareer);

    if(isParticipateCareer == '0' || isParticipateCareer == '')
    {
      
      
      this.academicForm.controls['AgricultureNaturalResources'].setValue(false);
      this.academicForm.controls['ArtMediaEntertainment'].setValue(false);
      this.academicForm.controls['BuildingConstructionTechnologies'].setValue(false);
      this.academicForm.controls['BusinessFinance'].setValue(false);
      this.academicForm.controls['Education'].setValue(false);
      this.academicForm.controls['EnergyEnvironmentUtilities'].setValue(false);
      this.academicForm.controls['EngineeringArchitecture'].setValue(false);
      this.academicForm.controls['FashionInteriorDesign'].setValue(false);
      this.academicForm.controls['HealthSciencesMedicalTechnology'].setValue(false);
      this.academicForm.controls['HospitalityTourismRecreation'].setValue(false);
      this.academicForm.controls['InformationCommunicationTechnologies'].setValue(false);
      this.academicForm.controls['ManufacturingProductDevelopment'].setValue(false);
      this.academicForm.controls['MarketingSalesServices'].setValue(false);
      this.academicForm.controls['PublicServices'].setValue(false);
      this.academicForm.controls['Transportation'].setValue(false);          
      this.showhighSchool = true;
    }
    else{
      this.showhighSchool = false;
    }

  }

  /* highSchoolsList() {
    this.loading = true;
    
    this.highSchoolSub =  this.api.highSchoolsList()
        .subscribe(responseData => {
            if ( responseData.status === 1) {
                this.highSchoolsData = responseData.data.highschool;
            }
            this.loading = false;
            
        });
  } */

  renderHero = (data: any) : SafeHtml => {
    //console.log(data);
    let html = `<span>${data.name}</span>`;
    return html;
  };

  
  changePdf(url){

    this.pdfSrc = url;
    //console.log(this.pdfSrc);
    this.openDialog();
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogPdfComponent, {
      height: '600px',
      data: { url: this.pdfSrc }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/profile/academic-information/academic-information.component.ts